import React from 'react'

import { Page } from '../../../../components/layouts/page'
import { Column } from '../../../../components/layouts/columns'
import { Form } from '../../../../components/ui/form'
import { FormNotices } from './form/formNotices'
import useEditNotices from './hooks/useEditNotices'

export const AdminEditNotices = () => {
  const { loading, formContext, setFormContext, handleEditNotice } = useEditNotices()

  return (
    <Page.Section className="is-fullheight-with-navbar">
      <Form.Root
        action={() => {
          handleEditNotice()
        }}
      >
        <Column.Root>
          <Column.Content>
            <p className="subtitle is-size-3">Editar Aviso</p>
          </Column.Content>
        </Column.Root>
        <FormNotices loading={loading} values={formContext} setValues={setFormContext} disabledList={{}} />
      </Form.Root>
    </Page.Section>
  )
}
